import {defer, once} from 'lodash';

export function mixinZoomState($scope, setWatcher = false, zoomAxis = 'xAxis') {
    syncScrolling();
    setZoomState($scope.zoomstate);
    // Set watcher only if specified to prevent leaks
    if (setWatcher) {
        $scope.$watch('zoomstate', setZoomState, true);
    }
    $scope.zoomstateReset = resetZoom;

    function syncScrolling() {
        const axis = $scope.chart[zoomAxis];
        const events = axis.events || (axis.events = {});
        events.setExtremes = (e) => {
            // Check for original event, prevent feedback loop
            if (e.trigger === 'zoom') {
                $scope.zoomstate.min = e.min ? e.min : null;
                $scope.zoomstate.max = e.max ? e.max : null;
                $scope.$evalAsync();
            }
        };
    }

    function destroyZoomButton(chart) {
        if (chart.resetZoomButton) {
            chart.resetZoomButton = chart.resetZoomButton.destroy();
            delete chart.resetZoomButton;
        }
    }

    function setZoomState(zoomstate) {
        // It is null while updating
        if ($scope.chart && $scope.chart.getHighcharts && $scope.chart.series) {
            const chart = $scope.chart.getHighcharts();
            const axis = chart[zoomAxis];
            if (!axis) {
                return;
            }
            if (zoomstate)
                axis[0].setExtremes(zoomstate.min, zoomstate.max, undefined, false, { trigger: 'syncZoom' });
            const hideZoomButton = chart.options.chart ? chart.options.chart.hideZoomButton : false;
            if (hideZoomButton) {
                destroyZoomButton(chart);
            } else {
                if (chart.resetZoomButton && zoomstate && zoomstate.min == null) {
                    destroyZoomButton(chart);
                } else if (!chart.resetZoomButton && zoomstate.min != null) {
                    chart.showResetZoom();
                }
            }
            $scope.$applyAsync();
        } else if ($scope.chart && zoomstate && zoomstate.min) {
            // Small hack to wait until getHighCharts() becomes available
            defer(once(setZoomState.bind(undefined, zoomstate)));
        }
    }

    function resetZoom() {
        if ($scope.chart && $scope.chart.getHighcharts) {
            const chart = $scope.chart.getHighcharts();
            chart.zoomOut();
            destroyZoomButton(chart);
        }
    }
}
